import { getter, setter } from "./Traps";
import { CALLABLE_HOOKS } from "../Hooks";
import { STR_ERRORS } from "../../Strings";
import { queryValidators } from "../../helpers";
import { connectionStore, ConnectionNames } from "../../Stores";
import { ClassDecoratorFactory } from "../ClassDecoratorFactory";
export const connectionName = ConnectionNames.sports;
export const SportsbookConnection = ClassDecoratorFactory(
// this function is non awaitable!
// we can't reference it's return value in any way
(instance, params) => {
    var _a, _b;
    const conn = connectionStore.get(connectionName);
    if (typeof conn === "undefined") {
        throw new Error(STR_ERRORS.NoConnectionsAvailable);
    }
    instance[CALLABLE_HOOKS.isValidQuery] = typeof ((_b = (_a = params) === null || _a === void 0 ? void 0 : _a.query) === null || _b === void 0 ? void 0 : _b.type) !== "undefined"
        ? queryValidators[params.query.type]
        : queryValidators.default;
    if (instance.query) {
        instance.query = instance.query;
    }
}, {
    get: getter,
    set: setter.bind(undefined, connectionName)
});
//# sourceMappingURL=SportsbookConnection.js.map